import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Image from 'next/image';

import banner from "../../../public/static/images/features/BannerMain.png";
import Container from '../../Common/Container';

const Hero = ({ pageTitle, title1, title2, title3, subtitle }) => {
  return (
    <Container mb={{ xs: 6, md: 10 }}>
      <header>
        <Box mt={5} mb={{ xs: 30, md: 40 }}>
          {pageTitle && (
            <Typography
              sx={{
                textTransform: "uppercase",
                fontWeight: "medium",
              }}
              gutterBottom
              color={"textSecondary"}
              align={"center"}
            >
              {pageTitle}
            </Typography>
          )}
          <Typography
            component={"h1"}
            fontWeight={700}
            variant={"h3"}
            mb={4}
            align={"center"}
          >
            {title1}{" "}
            <Typography
              color={"primary"}
              component={"span"}
              variant={"inherit"}
            >
              {title2}{" "}
            </Typography>
            {title3}
          </Typography>

          {subtitle && (
            <Typography
              variant="h6"
              component="h2"
              align={"center"}
              color={"textSecondary"}
              mx="15%"
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </header>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            maxWidth: 780,
            zIndex: 99,
          }}
        >
          <Image
            src={banner}
            alt="Fluicity illustration"
            width={780}
            height={472}
            layout="responsive"
            priority
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Hero;
